// extracted by mini-css-extract-plugin
export default {"item":"FilterItem-module__item___Pyyti","image":"FilterItem-module__image___SUMz7"};